<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center p-t-40 p-b-40" style="gap: 20px;">
            <img
              :src="`https://claimify-api.hayokmedicare.ng/image/${client.user.user_image}`"
              class="header-avatar"
              onerror="this.onerror=null; this.src='/assets/img/kgshia_logo.png'"
            />
            <div class="text-white">
              <h2 class="page-title mb-1">{{ client.user.full_name }}</h2>
              <div class="d-flex align-items-center flex-wrap" style="gap: 8px; margin-top: 6px;">
                <span class="header-id-badge">
                  <i class="fe fe-credit-card mr-1"></i>{{ client.user.id_card_number }}
                </span>
                <span v-if="client.user.status == 'active'" class="header-status header-status--active">
                  <i class="fe fe-check-circle mr-1"></i> Active
                </span>
                <span v-else class="header-status header-status--inactive">
                  <i class="fe fe-alert-circle mr-1"></i> Inactive
                </span>
                <span v-if="client.user.sector" class="header-id-badge">
                  <i class="fe fe-layers mr-1"></i>{{ client.user.sector }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Action Bar ──────────────────────────────────────── -->
        <div class="card action-card shadow mb-4"
          v-if="user.type != 'provider_employee' || user.type == 'provider'">
          <div class="card-body py-3 px-4">
            <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">

              <button class="btn btn-sm btn-outline-primary" @click="streamPic" data-toggle="modal" data-target="#example_01">
                <i class="fe fe-camera mr-1"></i> Take Photo
              </button>

              <label class="btn btn-sm btn-outline-secondary mb-0" style="cursor: pointer;">
                <i class="fe fe-upload mr-1"></i> Upload Picture
                <input type="file" accept="image/*" style="display:none;" v-on:change="attachPic" />
              </label>

              <router-link :to="{ path: '/client/biometrics/' + client.user.id }">
                <button class="btn btn-sm btn-outline-info">
                  <i class="mdi mdi-hand mr-1"></i> Biometrics
                </button>
              </router-link>

              <button class="btn btn-sm btn-outline-dark" @click="printMe">
                <i class="fe fe-printer mr-1"></i> Print
              </button>

              <a :href="`/patient/${client.user.type}/${$route.params.id}`">
                <button class="btn btn-sm btn-outline-info">
                  <i class="mdi mdi-medical-bag mr-1"></i> Utilizations
                </button>
              </a>

              <router-link :to="{ path: '/add-dependent/' + $route.params.id }">
                <button class="btn btn-sm btn-outline-info" @click="findDependents">
                  <i class="fe fe-users mr-1"></i> Dependents
                </button>
              </router-link>

              <router-link :to="{ path: '/edit-user/' + $route.params.id }">
                <button class="btn btn-sm btn-outline-dark">
                  <i class="fe fe-edit mr-1"></i> Edit
                </button>
              </router-link>

              <button type="button" class="btn btn-sm btn-outline-dark" data-toggle="modal" data-target="#exampleModal">
                <i class="mdi mdi-credit-card mr-1"></i> Add Payment
              </button>

              <!-- More dropdown -->
              <div class="dropdown ml-auto">
                <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fe fe-more-horizontal mr-1"></i> More
                </button>
                <div class="dropdown-menu dropdown-menu-right" style="min-width: 200px;">
                  <div class="dropdown-item" role="button" @click="documentModal = !documentModal">
                    <i class="mdi mdi-file mr-2 text-info"></i> Add Document
                  </div>
                  <div class="dropdown-item" role="button"
                    data-toggle="modal" data-target="#slideRightModalAll" @click="getActivities">
                    <i class="fe fe-monitor mr-2 text-info"></i> Activities
                  </div>
                  <a :href="'/enrollee_slip/' + client.user.id" class="dropdown-item">
                    <i class="fe fe-printer mr-2 text-muted"></i> Print Slip
                  </a>
                  <template v-if="user && user.user_role == 1">
                    <div class="dropdown-divider"></div>
                    <div v-if="client.user.enabled_user == true"
                      class="dropdown-item text-danger" role="button" @click="deactivateUser">
                      <i class="fe fe-user-x mr-2"></i> Deactivate
                    </div>
                    <div v-else class="dropdown-item text-success" role="button" @click="enableUser">
                      <i class="fe fe-check-square mr-2"></i> Activate
                    </div>
                    <div class="dropdown-item text-danger" role="button" @click="deleteUser">
                      <i class="fe fe-trash-2 mr-2"></i> Delete
                    </div>
                  </template>
                </div>
              </div>

            </div>
          </div>

          <!-- Payment Modal -->
          <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content" style="border-radius:12px; overflow:hidden;">
                <div class="modal-header" style="background: linear-gradient(135deg,#1e3a5f,#2563eb);">
                  <h5 class="modal-title text-white" id="exampleModalLabel">
                    <i class="mdi mdi-credit-card mr-2"></i>Add Payment
                  </h5>
                  <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Description</label>
                    <input type="text" class="form-control" placeholder="Payment description" v-model="userPayment.description" />
                  </div>
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Amount</label>
                    <input type="text" class="form-control" placeholder="Amount" v-model="userPayment.amount" />
                  </div>
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Payment Proof</label>
                    <div class="fileinput fileinput-new" data-provides="fileinput">
                      <span class="btn btn-outline-secondary btn-sm btn-file">
                        <span class="fileinput-new"><i class="fe fe-upload mr-1"></i> Upload Picture</span>
                        <span class="fileinput-exists">Change</span>
                        <input type="file" accept="image/png, image/gif, image/jpeg" name="..." multiple v-on:change="attachPaymentProof" />
                      </span>
                      <span class="fileinput-filename ml-2"></span>
                      <a href="#" class="close fileinput-exists" data-dismiss="fileinput" style="float:none">&times;</a>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Cancel</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="addPayment">
                    <i class="fe fe-send mr-1"></i> Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Payment Modal -->

          <!-- Document Modal -->
          <b-modal v-model="documentModal" title="Add Document">
            <form @submit.prevent="uploadDocument">
              <div class="form-group">
                <label class="small font-weight-bold text-muted text-uppercase">Document Type</label>
                <v-select v-model="document.name" :options="document_types" />
              </div>
              <div class="form-group">
                <label class="small font-weight-bold text-muted text-uppercase">Upload File</label>
                <div class="fileinput fileinput-new" data-provides="fileinput">
                  <span class="btn btn-outline-secondary btn-sm btn-file">
                    <span class="fileinput-new"><i class="fe fe-upload mr-1"></i> Choose File</span>
                    <span class="fileinput-exists">Change</span>
                    <input type="file" name="..." v-on:change="attachDocument" />
                  </span>
                  <span class="fileinput-filename ml-2"></span>
                  <a href="#" class="close fileinput-exists" data-dismiss="fileinput" style="float:none">&times;</a>
                </div>
                <button type="button" @click="takePicAndroidDoc" class="btn btn-outline-info btn-sm mt-2">
                  <i class="fe fe-camera mr-1"></i> Take Picture
                </button>
              </div>
              <img v-if="documentImagefile" :src="documentImagefile" class="rounded mt-2 img-fluid" alt="Document Preview" />
              <button type="submit" class="btn btn-primary btn-block mt-3">
                <i class="fe fe-upload mr-1"></i> Submit
              </button>
            </form>
          </b-modal>
          <!-- End Document Modal -->

        </div>

        <!-- ── Main Content ────────────────────────────────────── -->
        <div class="row">

          <!-- Left column: printable ID card -->
          <div class="col-lg-8 col-md-12" id="printDiv" ref="printNow">
            <div class="card shadow-sm profile-card"
              style="background-image: url('/assets/img/kgshia_transparent.png'); background-size: cover; background-repeat: no-repeat;">
              <div class="card-body p-4">
                <div class="d-flex align-items-center mb-4" style="gap:16px;">
                  <span class="avatar avatar-xl">
                    <img src="/assets/img/kgshia_logo.png" class="rounded-circle" />
                  </span>
                  <div>
                    <h2 class="h3 text-info mb-0 font-weight-bold">KOGI STATE HEALTH INSURANCE AGENCY</h2>
                    <p class="h5 mb-0">(KGSHIA)</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 text-center">
                    <img
                      :src="`https://claimify-api.hayokmedicare.ng/image/${client.user.user_image}`"
                      class="img-fluid rounded"
                      onerror="this.onerror=null; this.src='/assets/img/kgshia_logo.png'"
                    />
                  </div>
                  <div class="col-md-8">
                    <ul class="list-group list-group-flush">
                      <li class="info-row">
                        <i class="fe fe-user info-icon"></i>
                        <div>
                          <p class="info-label">Name</p>
                          <p class="info-value">{{ client.user.lastname }} {{ client.user.firstname }}, {{ client.user.middlename }}</p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-credit-card info-icon"></i>
                        <div>
                          <p class="info-label">KGSHIA ID</p>
                          <p class="info-value"><code class="code-chip">{{ client.user.id_card_number }}</code></p>
                        </div>
                      </li>
                      <li class="info-row" v-if="client.user.sectorType == 'informal'">
                        <i class="fe fe-calendar info-icon"></i>
                        <div>
                          <p class="info-label">Expiry Date</p>
                          <p class="info-value">{{ client.user.expiry_date | moment("dddd, MMMM Do YYYY") }}</p>
                        </div>
                      </li>
                      <li class="info-row" v-if="client.provider">
                        <i class="fe fe-home info-icon"></i>
                        <div>
                          <p class="info-label">Facility to Access Care</p>
                          <p class="info-value">{{ client.provider.agency_name }}</p>
                        </div>
                      </li>
                      <li class="info-row" v-if="client.user.place_of_work != null">
                        <i class="fe fe-briefcase info-icon"></i>
                        <div>
                          <p class="info-label">MDA</p>
                          <p class="info-value">{{ client.user.place_of_work }}</p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-tag info-icon"></i>
                        <div>
                          <p class="info-label">Plan Type</p>
                          <p class="info-value">{{ client.user.plan_type }}</p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-layers info-icon"></i>
                        <div>
                          <p class="info-label">Sector</p>
                          <p class="info-value">{{ client.user.sector }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right sidebar -->
          <div class="col-lg-4 col-md-12">
            <div class="card shadow-sm" style="border-radius: 14px; border: none;">
              <div class="card-header border-0 pt-4 pb-2 px-4" style="background: #f8f9fa; border-radius: 14px 14px 0 0;">
                <h6 class="mb-0 font-weight-bold text-dark">
                  <i class="fe fe-info text-primary mr-2"></i>Other Details
                </h6>
              </div>
              <div class="card-body p-0">
                <ul class="list-group list-group-flush">
                  <li class="info-row">
                    <i class="fe fe-calendar info-icon"></i>
                    <div>
                      <p class="info-label">Date Enrolled</p>
                      <p class="info-value">{{ client.user.created_at | moment("dddd, MMMM Do YYYY") }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-for="(dep, index) in dependents" :key="dep.id">
                    <i class="fe fe-users info-icon"></i>
                    <div>
                      <p class="info-label">Dependent {{ index + 1 }}</p>
                      <p class="info-value">{{ dep.firstname }} {{ dep.lastname }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="client.enrolled_by != null">
                    <i class="fe fe-user-check info-icon"></i>
                    <div>
                      <p class="info-label">Enrolled By</p>
                      <p class="info-value">{{ client.enrolled_by.firstname }} {{ client.enrolled_by.lastname }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-hash info-icon"></i>
                    <div>
                      <p class="info-label">NIMC Number</p>
                      <p class="info-value">{{ client.user.nimc_number || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-tag info-icon"></i>
                    <div>
                      <p class="info-label">Virtual Account Number</p>
                      <p class="info-value">{{ client.user.virtual_account || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-user info-icon"></i>
                    <div>
                      <p class="info-label">Gender</p>
                      <p class="info-value">{{ client.user.gender }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-phone info-icon"></i>
                    <div>
                      <p class="info-label">Phone Number</p>
                      <p class="info-value">{{ client.user.phone_number }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-map-pin info-icon"></i>
                    <div>
                      <p class="info-label">LGA / Ward</p>
                      <p class="info-value">
                        <span v-if="client.local_government != null">{{ client.local_government.local_name }}</span>
                        <span v-if="client.ward != null"> / {{ client.ward.ward_name }}</span>
                      </p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-gift info-icon"></i>
                    <div>
                      <p class="info-label">Date of Birth</p>
                      <p class="info-value">{{ client.user.dob | moment("D/M/YYYY") }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-mail info-icon"></i>
                    <div>
                      <p class="info-label">Email</p>
                      <p class="info-value">{{ client.user.email || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-calendar info-icon"></i>
                    <div>
                      <p class="info-label">Expiry Date</p>
                      <p class="info-value">{{ client.user.expiry_date || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-smile info-icon"></i>
                    <div>
                      <p class="info-label">Marital Status</p>
                      <p class="info-value">{{ client.user.marital_status || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-briefcase info-icon"></i>
                    <div>
                      <p class="info-label">MDA</p>
                      <p class="info-value">{{ client.user.place_of_work || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-hash info-icon"></i>
                    <div>
                      <p class="info-label">Staff ID</p>
                      <p class="info-value">{{ client.user.salary_number || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-users info-icon"></i>
                    <div>
                      <p class="info-label">Category of Vulnerable Group</p>
                      <p class="info-value">{{ client.user.category_of_vulnerable_group || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-map info-icon"></i>
                    <div>
                      <p class="info-label">Address</p>
                      <p class="info-value">{{ client.user.address1 || '—' }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <!-- ── Transactions ─────────────────────────────────────── -->
        <div class="card table-card shadow mb-4 mt-4">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-credit-card" style="font-size:13px;"></i></div>
            <div>
              <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">
                {{ client.transactions.length }} Transactions
              </p>
            </div>
          </div>
          <div class="row" style="margin:0;">
            <div :class="trxtableclass">
              <div class="table-responsive">
                <table class="table align-td-middle mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th">S/N</th>
                      <th class="table-th">Transaction Type</th>
                      <th class="table-th">Transaction Amount</th>
                      <th class="table-th">Transaction Proof</th>
                      <th class="table-th">Description</th>
                      <th class="table-th">Date Created</th>
                      <th class="table-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="(trx, index) in client.transactions" v-bind:key="trx.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ trx.type }}</td>
                      <td>&#8358;{{ trx.amount | numeral(0, 0) }}</td>
                      <td>
                        <button class="btn btn-sm btn-outline-info" v-if="trx.type == 'offline'" @click="gotoTrxImage(trx)">
                          View Proof
                        </button>
                      </td>
                      <td>{{ trx.description }}</td>
                      <td>{{ trx.created_at | moment("dddd, MMMM Do YYYY") }}</td>
                      <td>
                        <button class="btn btn-sm btn-outline-danger" @click="deleteTrx(trx)">
                          <i class="fe fe-trash-2"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div :class="trxdocclass" v-show="trx_image">
              <img :src="`http://localhost:8000/documents/${trx_doc.document}`" class="img-fluid" v-if="trx_doc != null" />
            </div>
          </div>
        </div>

        <SingleClientDocuments :documents="client.documents || []" />
        <SingleClientCOF :cofs="client.cofs || []" />

      </div>

      <!-- ── Activities Slide-Right Modal ─────────────────────── -->
      <div class="modal fade modal-slide-right" id="slideRightModalAll" tabindex="-1" role="dialog"
        aria-labelledby="slideRightModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header align-items-center"
              style="background: linear-gradient(135deg,#1e3a5f,#2563eb);">
              <div class="d-flex align-items-center">
                <div class="mr-3 d-flex align-items-center justify-content-center"
                  style="width:38px;height:38px;background:rgba(255,255,255,.15);border-radius:10px;flex-shrink:0;">
                  <i class="fe fe-monitor text-white" style="font-size:1rem;"></i>
                </div>
                <div>
                  <h5 class="modal-title mb-0 text-white" id="slideRightModalLabel">User Activities</h5>
                  <small class="text-white-50">{{ client.user ? client.user.full_name : '' }}</small>
                </div>
              </div>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-0">
              <div class="table-responsive">
                <table class="table mb-0" style="font-size:.85rem;">
                  <thead style="background:#f8fafc;">
                    <tr>
                      <th class="px-3 py-3 activities-th">Date</th>
                      <th class="py-3 activities-th">User</th>
                      <th class="py-3 activities-th">Changes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="activity in activities.data" :key="activity.id" style="border-color:#f1f5f9;">
                      <td class="px-3 py-3">
                        <p class="mb-0" style="font-size:.83rem;">
                          {{ activity.created_at | moment("MMM Do YYYY") }}
                        </p>
                        <span class="badge badge-soft-success" style="font-size:.72rem;">
                          {{ activity.description }}
                        </span>
                      </td>
                      <td class="py-3" style="font-size:.83rem;">{{ activity.causer.full_name }}</td>
                      <td class="py-3">
                        <details>
                          <summary style="cursor:pointer;font-size:.8rem;color:#2563eb;">Show / Hide</summary>
                          <span v-for="(value, key) in activity.properties.attributes" :key="key"
                            class="d-block" style="font-size:.78rem;">{{ value }}</span>
                        </details>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal">
                <i class="fe fe-x mr-1"></i> Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal for Webcam Capture -->
      <div class="modal fade" id="example_01" tabindex="-1" role="dialog" aria-labelledby="example_02" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content" style="border-radius:12px; overflow:hidden;">
            <div class="modal-header" style="background: linear-gradient(135deg,#1e3a5f,#2563eb);">
              <h5 class="modal-title text-white"><i class="fe fe-camera mr-2"></i>Take Photo</h5>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-center">
              <video id="video" width="100%" height="auto" autoplay></video>
              <div class="mt-3">
                <button @click="takePic" class="btn btn-outline-dark mr-2">
                  <i class="fe fe-aperture mr-1"></i> Snap Photo
                </button>
              </div>
              <canvas id="canvas" width="600px" height="450px" style="display:none;"></canvas>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Ends -->

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
      <PhotoCropper ref="photoCropper" />
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
// import { WebCam } from "vue-web-cam";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import PhotoCropper from "@/components/PhotoCropper.vue";
import SingleClientDocuments from "./components/SingleClientDocuments";
import SingleClientCOF from "./components/SingleClientCOF.vue";

export default {
  components: { PhotoCropper,
    Navbar,
    Loading,
    SingleClientDocuments,
    SingleClientCOF,
  },
  data() {
    return {
      user: null,
      trx_image: false,
      auth_user: "",
      client: { user: {}, transactions: [] },
      trx_doc: null,
      notes: "",
      dependents: "",
      medications: "",
      healthFacility: "",
      signature: "",
      enrolled_by: "",
      singleward: "",
      singlelga: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      transactionID: "",
      agency_id: "",
      imagefile: "",
      image: "",
      paymentProofFile: "",
      paymentProofImage: "",
      output: "",
      singletpa: "",
      trxdocclass: "col-md-4",
      trxtableclass: "col-md-12",
      pictureShower: true,
      activities: { data: [] },
      documentModal: false,
      documentImagefile: "",
      document_types: [
        "Registration Form",
        "Revalidation Form",
        "Renewal Receipt",
        "Credential",
        "Change of Facility",
        "Others",
      ],
      document: {
        name: "",
        document: "",
        document_picture: "",
      },
      userPayment: {
        description: "",
        amount: "",
      },
      transaction_ref_length: 50,
      video_settings: {
        video: {
          width: {
            min: 1280,
            ideal: 1920,
            max: 2560,
          },
          height: {
            min: 720,
            ideal: 1080,
            max: 1440,
          },
          facingMode: "environment",
        },
      },
    };
  },
  mounted() {
    this.print();

    var video = document.getElementById("video");
    // Get access to the camera!
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      // Not adding `{ audio: true }` since we only want video now
      // navigator.mediaDevices.getUserMedia({ video: true}).then(function(stream) {
      navigator.mediaDevices
        .getUserMedia(this.video_settings)
        .then(function (stream) {
          //video.src = window.URL.createObjectURL(stream);
          video.srcObject = stream;
          video.play();
        });
    }

    var canvas = document.getElementById("canvas");
    var context = canvas.getContext("2d");
    // var video = document.getElementById('video');

    // Trigger photo take
    document.getElementById("snap").addEventListener("click", function () {
      context.drawImage(video, 0, 0, 500, 350);

      // get image
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      console.log(image);
      localStorage.setItem("snap", image);
      // this.this.uploadPic()
    });
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
      .then((response) => {
        this.client = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  computed: {
    randomTransId() {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < this.transaction_ref_length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      console.log({ result });
      return result;
    },
  },

  methods: {
    addPayment() {
      if (confirm("Are you sure you want to Submit?")) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/make/transaction`, {
            user_id: this.$route.params.id,
            agency_id: 90,
            description: this.userPayment.description,
            amount: this.userPayment.amount,
            type: "offline",
            status: "approved",
            transaction_ref: this.randomTransId,
          })
          .then((response) => {
            this.transactionID = response.data.id;

            // this.isLoading = false;
            // this.$toasted.success("Payment Added Successfully", {
            //   position: "top-center",
            //   duration: 3000,
            // });
            // this.fetchUser()
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });

        this.userPayment.description = "";
        this.userPayment.amount = "";
      }

      // if (this.transactionID !== "") {
      //   }

      setTimeout(() => {
        this.uploadPaymentProof();
      }, 3000);
    },

    changeNumber() {
      this.isLoading = true;
      this.axios
        .patch(`/api/v1/auth/id-card-number/change/${this.$route.params.id}`)
        .then((response) => {
          console.log(response);
          // this.getClients()
          this.$toasted.success("Changed Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },
    // User picture upload: crop first, then save through uploadcustomerpicImage
    attachPic(event) {
      const file = event.target.files[0];
      event.target.value = "";
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => this.cropAndSavePic(e.target.result);
      reader.readAsDataURL(file);
    },

    attachPaymentProof(event) {
      this.user = JSON.parse(localStorage.getItem("user"));
      console.log(event);
      this.paymentProofFile = event.target.files[0];
      console.log(this.paymentProofFile);
    },

    uploadPaymentProof() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));

      var formData = new FormData();
      formData.append("transaction_id", this.transactionID);
      formData.append("user_id", this.$route.params.id);
      formData.append("document", this.paymentProofFile);

      this.axios
        .post("/api/v1/auth/uploadTransactionDocument", formData)
        .then((response) => {
          this.paymentProofImage = response.data.document;
          console.log(response.data.document);
          this.isLoading = false;
          this.$toasted.success("Payment Added Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.fetchUser();
        });
    },

    async print() {
      const el = this.$refs.printNow;

      const options = {
        type: "dataURL",
      };
      this.output = await this.$html2canvas(el, options);
    },
    streamPic() {
      console.log("hello pic");

      var video = document.getElementById("video");
      // Get access to the camera!
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Not adding `{ audio: true }` since we only want video now
        navigator.mediaDevices
          .getUserMedia(this.video_settings)
          .then(function (stream) {
            //video.src = window.URL.createObjectURL(stream);
            video.srcObject = stream;
            video.play();
          });
      }
    },
    printMe() {
      var printContents = document.getElementById("printDiv").innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
    attachSign(event) {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.signature = event.target.files[0];
      console.log(event);
      this.uploadSign();
    },

    authUser() {
      this.axios
        .get(`/api/v1/auth/user`)
        .then((response) => {
          this.auth_user = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    takePic() {
      var video = document.getElementById("video");
      var canvas = document.getElementById("canvas");
      var context = canvas.getContext("2d");

      context.drawImage(video, 0, 0, 640, 480);
      // close the camera dialog, then crop the snapshot and save it
      // eslint-disable-next-line no-undef
      $("#example_01").modal("hide");
      this.cropAndSavePic(canvas.toDataURL("image/jpeg"));
    },

    async cropAndSavePic(src) {
      const cropped = await this.$refs.photoCropper.open(src);
      if (cropped) this.savePic(cropped);
    },

    savePic(image) {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/uploadcustomerpicImage`, {
          user_image: image,
          user_id: this.$route.params.id,
        })
        .then((response) => {
          console.log(response);
          this.$toasted.success("uploaded Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.fetchUser();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    deleteUser() {
      if (confirm("Are you Sure you want to delete this user")) {
        this.axios
          .delete(`/api/v1/auth/deleteUser/${this.$route.params.id}`)
          .then((response) => {
            console.log(response);
            // this.getClients()
            this.$toasted.success("Deleted Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    enableUser() {
      if (confirm("Are you Sure you want to activate?")) {
        this.axios
          .post(`/api/v1/auth/enableUser/` + this.$route.params.id)
          .then(() => {
            this.fetchUser();
            this.$toasted.info("Activated Successfully!", {
              position: "top-center",
              duration: 8000,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    deactivateUser() {
      if (confirm("Are you Sure you want to deactivate?")) {
        this.axios
          .post(`/api/v1/auth/disableUser/` + this.$route.params.id)
          .then(() => {
            this.fetchUser();
            this.$toasted.info("Deactivated Successfully!", {
              position: "top-center",
              duration: 8000,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    getActivities() {
      this.axios
        .get(`/api/v1/auth/activities-on-user/${this.$route.params.id}`, {
          params: {
            model: "App\\Models\\User",
          },
        })
        .then((response) => {
          this.activities = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async takePicAndroidDoc() {
      this.documentModal = false;

      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: CameraSource.Camera,
      });

      this.documentImagefile = "data:image/png;base64," + image.base64String;

      this.documentModal = true;
    },
    attachDocument(event) {
      console.log(event);
      this.document.document = event.target.files[0];
    },

    uploadDocument() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      var formData = new FormData();
      formData.append("type_id", this.$route.params.id);
      formData.append("user_id", this.$route.params.id);
      formData.append("name", this.document.name);
      formData.append("document", this.document.document);
      formData.append("document_picture", this.documentImagefile);
      formData.append("type", "enrollee");
      this.axios
        .post("/api/v1/auth/documents", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("Document uploaded Successfully", {
            position: "top-center",
            duration: 3000,
          });

          this.fetchUser();

          this.document.name = "";
        })
        .catch((error) => {
          this.$toasted.error("Error Uploading", {
            position: "top-center",
            duration: 3000,
          });
          console.error(error);
          this.isLoading = false;
        });
    },

    deleteTrx(trx) {
      if (confirm("Are you Sure you want to delete?")) {
        this.axios
          .delete(`/api/v1/auth/delete/transaction/${trx.id}`)
          .then((response) => {
            console.log(response);
            this.fetchUser();
            this.$toasted.success("Deleted Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    gotoTrxImage(trx) {
      this.axios
        .get(`/api/v1/auth/get/transaction-document/${trx.id}`)
        .then((response) => {
          console.log(response);
          this.$toasted.success("Gotten Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.trx_doc = response.data.data;
          this.trx_image = true;
          this.trxtableclass = "col-md-8";
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.client = response.data;
          this.dependents = response.data.dependents;

          //get dependents
          this.axios
            .post(`/api/v1/auth/allDependantsUser`, {
              agency_id: 90,
              id_card_number: this.client.id_card_number,
              user_id: this.$route.params.id,
            })
            .then((response) => {
              let answers = response.data;
              answers;
              console.log(response);
            })
            .catch((error) => {
              console.error(error);
            });
          //end of get dependents
        })
        .catch((error) => {
          console.error(error);
        });
    },
    findDependents() {
      //get dependents
      this.axios
        .post(`/api/v1/auth/allDependantsUser`, {
          agency_id: 90,
          id_card_number: this.client.user.id_card_number,
          user_id: this.$route.params.id,
        })
        .then((response) => {
          let answers = response.data;
          answers;
          this.fetchUser();
          console.log({ response });
        })
        .catch((error) => {
          console.error(error);
        });
      //end of get dependents
    },

    uploadPic() {
      this.isLoading = true;
      let snap = localStorage.getItem("snap");

      var formData = new FormData();
      formData.append("user_image", snap);
      this.axios
        .post("/api/v1/auth/uploadUserImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          // this.getUser()
        });
    },
    // uploadPaymentProof() {
    //   this.isLoading = true;
    //   let snap = localStorage.getItem("snap");

    //   var formData = new FormData();
    //   formData.append("user_image", snap);
    //   this.axios
    //     .post("/api/v1/auth/uploadUserImage", formData, {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     })
    //     .then((response) => {
    //       console.log(response);
    //       this.isLoading = false;
    //       this.$breadstick.notify("Profile Image changed Successfully!", {
    //         position: "top-right",
    //       });
    //       // this.getUser()
    //     });
    // },
  },
  created() {
    this.fetchUser();
    this.findDependents();
    this.streamPic();
  },
};
</script>
<style>
  #slideRightModalAll {
    position: fixed !important;
  }

  #slideRightModalAll .modal-dialog {
    position: fixed !important;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100vh !important;
    display: flex;
    flex-direction: column;
  }

  #slideRightModalAll .modal-content {
    height: 100vh !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  #slideRightModalAll .modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  #slideRightModalAll .modal-header,
  #slideRightModalAll .modal-footer {
    flex-shrink: 0;
  }
</style>

<style scoped>
/* ── Page Header ─────────────────────────────────────── */
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 60px;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0;
}

.header-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255, 255, 255, 0.4);
  flex-shrink: 0;
}

.header-id-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 0.78rem;
  padding: 3px 10px;
  border-radius: 20px;
  font-weight: 500;
}

.header-status {
  display: inline-flex;
  align-items: center;
  font-size: 0.78rem;
  padding: 3px 10px;
  border-radius: 20px;
  font-weight: 600;
}

.header-status--active {
  background: rgba(16, 185, 129, 0.25);
  color: #6ee7b7;
}

.header-status--inactive {
  background: rgba(245, 158, 11, 0.25);
  color: #fcd34d;
}

/* ── Action Card ─────────────────────────────────────── */
.action-card {
  border-radius: 14px;
  border: none;
}

/* ── Profile / Certificate Card ───────────────────────── */
.profile-card {
  border-radius: 14px;
  border: none;
  overflow: hidden;
}

.code-chip {
  display: inline-block;
  background: #eff6ff;
  color: #2563eb;
  font-size: 0.78rem;
  padding: 2px 8px;
  border-radius: 6px;
  font-family: monospace;
}

/* ── Info Rows ───────────────────────────────────────── */
.info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 20px;
  list-style: none;
  border-bottom: 1px solid #f1f5f9;
}

.info-row:last-child {
  border-bottom: none;
}

.info-icon {
  color: #2563eb;
  font-size: 0.95rem;
  margin-top: 2px;
  flex-shrink: 0;
}

.info-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 1px;
  font-weight: 600;
}

.info-value {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.9rem;
  margin-bottom: 0;
}

/* ── Table (design-system, inlined locally — kgshia has no global
     design-system.css yet) ────────────────────────────── */
.table-card { border-radius: 14px !important; border: none !important; overflow: hidden; }
.form-card-header {
  display: flex; align-items: center; gap: 12px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #1e3a5f, #2563eb);
}
.section-number {
  width: 28px; height: 28px; border-radius: 50%;
  background: rgba(255, 255, 255, 0.25); color: #fff;
  font-size: 13px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.table-head { background: #f8fafc; }
.table-th {
  font-size: 0.75rem !important; text-transform: uppercase; letter-spacing: 0.04em;
  color: #64748b !important; font-weight: 600 !important;
  border-bottom: 2px solid #e2e8f0 !important; padding: 12px 16px !important;
  white-space: nowrap;
}
.table-row { border-color: #f1f5f9 !important; transition: background 0.15s; }
.table-row:hover { background: #f8fafc !important; }

/* ── Activities table ────────────────────────────────── */
.activities-th {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  font-weight: 600;
  border-bottom: 2px solid #e2e8f0;
}

/* ── Legacy / kept ───────────────────────────────────── */
.spacer {
  margin-left: 1px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.spacer-image {
  margin-top: 25px;
}
.spacer-top-bottom {
  margin-top: 10px;
  margin-bottom: 10px;
}
.spacer-top {
  margin-top: 50px;
}
#container {
  margin: 0px auto;
  width: 500px;
  height: 375px;
  border: 10px #333 solid;
}
#videoElement {
  width: 500px;
  height: 375px;
  background-color: #666;
}
th {
  text-align: center;
}

td {
  width: fit-content;
  text-align: center;
}

.payment__proof {
  width: 20%;
}

.payment__proof,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: inline-block;
}
</style>
